export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 32
export const PASSWORD_POLICY_PATTERN = /^(?=.*[A-Za-z])(?=.*\d)[\x21-\x7E]{8,32}$/

export const isPasswordPolicyValid = (value: string): boolean =>
    PASSWORD_POLICY_PATTERN.test(value)
